import Masonry from "masonry-layout";
import utils from '../utils';

const NS = 'ProfileDetailBlock';
const CLS = 'profileDetailBlock';

export class ProfileDetailBlock {
	constructor(element) {
		this.$el = $(element);
		this.$slider = this.$el.find(`.${CLS}-slider`);
		this.$videoImg = this.$el.find(`.${CLS}-video-img`);
		this.$grid = this.$el.find(`.grid`);
		this.$playVideo = this.$el.find(`.playVideo`);
		this.$video = this.$el.find(`.${CLS}-video`);

		const videoType = this.$el.find(`.${CLS}-video-vid`).data('videoType');
		const videoId = this.$el.find(`.${CLS}-video-vid`).data('videoId');
		const video = this.$el.find(`.${CLS}-video-vid`);
		const isPrepCls = 'is-preparing';
		const isPlayCls = 'is-playing';

		const imgWidth = this.$videoImg.outerWidth();
		const imgHeight = this.$videoImg.outerHeight();
		video.css({
			width: imgWidth,
			height: imgHeight,
		});

		  var elem = document.querySelector('.grid');
		  var msnry = new Masonry( elem, {
		  itemSelector: '.grid-item',
		  columnWidth: 200
		  });
		  var msnry = new Masonry( '.grid', {
		  });

	this.$water = this.$el.find(`.${CLS}-water`);
	this.$waterPractices = this.$el.find(`.water-practices`);
	this.$water.on( "mouseenter", () => {
		this.$waterPractices.css("display", "block");
	}).on( "mouseleave", () => {
		this.$waterPractices.css("display", "none");
	});

	this.$climate = this.$el.find(`.${CLS}-climate`);
	this.$climatePractices = this.$el.find(`.climate-practices`);
	this.$climate.on( "mouseenter", () => {
		this.$climatePractices.css("display", "block");
	}).on( "mouseleave", () => {
		this.$climatePractices.css("display", "none");
	});

	this.$biodiversity = this.$el.find(`.${CLS}-biodiversity`);
	this.$biodiversityPractices = this.$el.find(`.biodiversity-practices`);
	this.$biodiversity.on( "mouseenter", () => {
		this.$biodiversityPractices.css("display", "block");
	}).on( "mouseleave", () => {
		this.$biodiversityPractices.css("display", "none");
	});

	this.$stewardship = this.$el.find(`.${CLS}-stewardship`);
	this.$stewardshipPractices = this.$el.find(`.stewardship-practices`);
	this.$stewardship.on( "mouseenter", () => {
		this.$stewardshipPractices.css("display", "block");
	}).on( "mouseleave", () => {
		this.$stewardshipPractices.css("display", "none");
	});

	this.$land = this.$el.find(`.${CLS}-land`);
	this.$landPractices = this.$el.find(`.land-practices`);
	this.$land.on( "mouseenter", () => {
		this.$landPractices.css("display", "block");
	}).on( "mouseleave", () => {
		this.$landPractices.css("display", "none");
	});

	this.$wellbeing = this.$el.find(`.${CLS}-wellbeing`);
	this.$wellbeingPractices = this.$el.find(`.wellbeing-practices`);
	this.$wellbeing.on( "mouseenter", () => {
		this.$wellbeingPractices.css("display", "block");
	}).on( "mouseleave", () => {
		this.$wellbeingPractices.css("display", "none");
	});

	this.$clip = this.$el.find(`.${CLS}-clip`);
	this.$clipPractices = this.$el.find(`.clip-practices`);
	this.$clip.on( "mouseenter", () => {
		this.$clipPractices.css("display", "block");
	}).on( "mouseleave", () => {
		this.$clipPractices.css("display", "none");
	});

	this.$responsibility = this.$el.find(`.${CLS}-responsibility`);
	this.$responsibilityPractices = this.$el.find(`.responsibility-practices`);
	this.$responsibility.on( "mouseenter", () => {
		this.$responsibilityPractices.css("display", "block");
	}).on( "mouseleave", () => {
		this.$responsibilityPractices.css("display", "none");
	});
	this.$playVideo.on('click', (e) => {
		this.$video.addClass(isPrepCls);
		utils.scrollToEl(this.$video[0]);
		// Is Vimeo video ?
		// Create a hidden Vimeo Player that will be popup later.
		// @ref https://github.com/vimeo/player.js
		if (this.isVimeoLink(videoType)) {
			video.append('<div data-vimeo-id="' + videoId + '" id="vimeoVideo" />');
			vimeoPlayer = new Player('vimeoVideo');
		}

		// Is Youtube video ?
		// Append an Iframe
		if (this.isYoutubeLink(videoType)) {
			const embedLink = 'https://www.youtube.com/embed/' + videoId;
			video.append('<iframe src="' + embedLink + '" allow="autoplay" />');
		}

		// Is Youku video ?
		// Append an Iframe
		if (this.isYoukuLink(videoType)) {
			const embedLink = 'https://player.youku.com/embed/' + videoId;
			video.append('<iframe src="' + embedLink + '" allow="autoplay" />');
		}

		// Start Vimeo video.
		if (videoType === 'vimeo') vimeoPlayer.play();

		// Start Youtube video.
		if (videoType === 'youtube') {
			const src = $('iframe', video).attr('src');
			$('iframe', video).attr('src', src + '?autoplay=1&rel=0');
		}

		// Start Youku video.
		if (videoType === 'youku') {
			const src = $('iframe', video).attr('src');
			$('iframe', video).attr('src', src + '?autoplay=1&rel=0&showinfo=0');
		}

		const wgWidth = this.$video.outerWidth();
		const videoWidth = wgWidth - 50;
		const videoHeight = (wgWidth - 50) / 16 * 10; // Video ratio is 16:9

		// prevent video jumping
		this.$videoImg.css('height', videoHeight);

		video.show().animate({
			width: videoWidth,
			height: videoHeight,
		}, 500, 'linear');
		setTimeout(() => {
			this.$video.removeClass(isPrepCls);
			this.$video.addClass(isPlayCls);
		}, 500);
	});

	}
	isVimeoLink(videoType) {
		return videoType === 'vimeo';
	}

	isYoutubeLink(videoType) {
		return videoType === 'youtube';
	}

	isYoukuLink(videoType) {
		return videoType === 'youku';
	}

}
